import { Model }                 from '@mathquis/modelx';
import Connector                 from '@mathquis/modelx/lib/types/connector';
import session                   from '../currentSession';
import SharedAuthCookieConnector from './connectors/SharedAuthCookieConnector';

const sharedAuthCookieConnector = new SharedAuthCookieConnector() as any;

// Seuls token et refreshToken sont persistés (cookies partagés) : user_data est recalculé depuis le token
export default class SessionUser extends Model {
	static get connector(): Connector {
		return sharedAuthCookieConnector;
	}

	static get path(): string {
		return '/user/current';
	}

	static get defaults(): object {
		return {
			id: 'current',
			user_data: {
				user_informations: {
					avatar: '',
					firstName: '',
					lastName: ''
				}
			},
			token: '',
			refreshToken: '',
		};
	}

	public isManager(): boolean {
		return !!session.getRoleUrnArr().find(role => !!role.match(/LSD/g) && !!role.match(/MANAGER/g));
	}

	public isAdmin() {
		return !!session.getRoleUrnArr().find(role => !!role.match(/LSD/g) && !!role.match(/ADMIN/g));
	}

	public isSuperAdmin() {
		return !!session.getRoleUrnArr().find(role => !!role.match(/LSD/g) && !!role.match(/SUPER_ADMIN/g));
	}
}
